import { ReactNode, useCallback, MouseEvent, MouseEventHandler } from 'react';
import { default as css } from './GenericButton.module.scss';
import classNames from 'classnames';
import { BaseButtonBase } from '../BaseButtonBase/BaseButtonBase';
import { GenericButtonProps } from './GenericButton.types';

/**
 * A generic button control used to wrap around other elements and turn elements into
 * a button such a `div` containing text.
 *
 * @param onClick - {@link GenericButtonProps.onClick onClick} description.
 * @param id - {@link GenericButtonProps.id id} description.
 * @param type - {@link GenericButtonProps.type type} description.
 * @param title - {@link GenericButtonProps.title title} description.
 * @param className - {@link GenericButtonProps.className className} description.
 * @param onClick - {@link GenericButtonProps.onClick onClick} description.
 * @param disabled - {@link GenericButtonProps.disabled disabled} description.
 * @param ariaChecked - {@link GenericButtonProps.ariaChecked ariaChecked} description.
 * @param style - {@link GenericButtonProps.style style} description.
 * @param ariaLabel - {@link GenericButtonProps.ariaLabel ariaLabel} description.
 * @param children - {@link GenericButtonProps.children children} description.
 */
const GenericButton = ({
    onClick,
    type,
    title,
    ariaLabel,
    className,
    children,
    id,
    ariaChecked,
    classes,
    disabled,
    style,
}: GenericButtonProps): ReactNode => {
    const onClickImpl: MouseEventHandler<HTMLButtonElement> | undefined = onClick;
    const onClickIn = useCallback((event: MouseEvent<HTMLButtonElement>): void | undefined => {
        event.stopPropagation();

        return onClickImpl && onClickImpl(event);
    }, [onClickImpl]);

    return (
        <BaseButtonBase
            type={type}
            title={title}
            ariaLabel={ariaLabel}
            onClick={onClickIn}
            className={classNames(css.genericButton, className)}
            focusVisibleClassName={classNames(css['focus-visible'], css.focus)}
            TouchRippleProps={{
                classes: {
                    root: css.ripple,
                },
            }}
            id={id}
            ariaChecked={ariaChecked}
            classes={classes}
            disabled={disabled}
            style={style}
        >
            {children}
        </BaseButtonBase>
    );
};

export default GenericButton;